import { createFileRoute } from "@tanstack/react-router";
import { getAthleteAssignedProgram } from "api-client";
import { z } from "zod";

import { RouteComponent } from "src/components/AthleteProgramRouteProgramRoute";
import { programGridZoomSearchSchema } from "src/contexts/ProgramGridZoomContext";
import { loaderHandler } from "src/lib/loaderHandler";

const searchSchema = z.object({
  comments: z.string().optional(),
  selectedWorkout: z.string().optional(),
  workoutItemId: z.string().optional(),
  zoom: programGridZoomSearchSchema,
});

export const Route = createFileRoute("/_auth/_athlete/programs/$programId")({
  component: RouteComponent,
  validateSearch: searchSchema,
  ssr: true,
  shouldReload: false,
  async loader({ params }) {
    return await loaderHandler(async () => {
      const programData = await getAthleteAssignedProgram({
        path: {
          id: params.programId,
        },
      }).then((res) => {
        return res.data.data;
      });

      return {
        data: {
          program: programData.program,
        },
        breadcrumb: {
          id: programData.program.id,
          label: programData.program.name,
          href: `/programs/${programData.program.id}`,
        },
      };
    });
  },
});
